export const LOGIN_ATTEMPT_KEY = 'session_login_attempt';
export const POST_LOGIN_PATH_KEY = 'session_post_login_path';
export const LOGIN_RETRY_WINDOW_MS = 15000;

export const DEFAULT_ME_URL = '/api/me';
/**
 * yarn start logs in through the backend's keycloak-local registration, whose Keycloak client allows
 * http://localhost:3000 redirects (the dev proxy's Forwarded header makes the backend build them).
 * Builds always use the regular registration.
 */
const REGISTRATION_ID = process.env.NODE_ENV === 'development' ? 'keycloak-local' : 'keycloak';
export const DEFAULT_LOGIN_URL = `/oauth2/authorization/${REGISTRATION_ID}`;
/** Runs the login flow with Keycloak's change-password action - the backend forwards kc_action. */
export const DEFAULT_CHANGE_PASSWORD_URL = `${DEFAULT_LOGIN_URL}?kc_action=UPDATE_PASSWORD`;
export const DEFAULT_LOGOUT_URL = '/logout';
export const DEFAULT_CSRF_COOKIE_NAME = 'XSRF-TOKEN';
export const DEFAULT_CSRF_FIELD_NAME = '_csrf';

export const readCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const getCurrentPath = (): string =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

/** Sends the user through Keycloak's change-password screen and back to the current page. */
export const startChangePassword = (
  changePasswordUrl: string = DEFAULT_CHANGE_PASSWORD_URL
): void => {
  sessionStorage.setItem(POST_LOGIN_PATH_KEY, getCurrentPath());
  window.location.href = changePasswordUrl;
};

interface SessionLogoutOptions {
  logoutUrl?: string;
  csrfCookieName?: string;
  csrfFieldName?: string;
}

/**
 * Spring rejects a GET logout once csrf is on and answers with a redirect to the Keycloak end
 * session endpoint, so the logout has to be a real form navigation and not an XHR.
 */
export const submitSessionLogout = ({
  logoutUrl = DEFAULT_LOGOUT_URL,
  csrfCookieName = DEFAULT_CSRF_COOKIE_NAME,
  csrfFieldName = DEFAULT_CSRF_FIELD_NAME,
}: SessionLogoutOptions = {}): void => {
  sessionStorage.removeItem(LOGIN_ATTEMPT_KEY);
  sessionStorage.removeItem(POST_LOGIN_PATH_KEY);

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = logoutUrl;

  const csrfToken = readCookie(csrfCookieName);
  if (csrfToken) {
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = csrfFieldName;
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);
  }

  document.body.appendChild(form);
  form.submit();
};
